import { ControlFacet } from '../models/controls/ControlFacet';

export interface ISignalData {
  signal: React.ReactNode;
  title?: string;
  key: string;
}

export interface IItemSignalControlProps {
  itemKey: string | undefined;
}

export interface IItemSignalControlOverrides {
  signals: ISignalData[];
}

export const itemLifeCycleSignalsControl =
  new ControlFacet<IItemSignalControlProps, IItemSignalControlOverrides>('itemLifeCycleSignalsControl');

export const itemSocialSignalsControl =
  new ControlFacet<IItemSignalControlProps, IItemSignalControlOverrides>('itemSocialSignalsControl');

export const itemStorageSignalsControl =
  new ControlFacet<IItemSignalControlProps, IItemSignalControlOverrides>('itemStorageSignalsControl');
